import { render, staticRenderFns } from "./details.vue?vue&type=template&id=be9c7090&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=be9c7090&prod&scoped=true&lang=css"
import style1 from "./details.vue?vue&type=style&index=1&id=be9c7090&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9c7090",
  null
  
)

export default component.exports